// extracted by mini-css-extract-plugin
export default {"vendorsNav":"vendorsNav__YzdlM","overlay":"overlay__NTYyO","active":"active__MDY1Z"};